
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homes/[modelNumber]",
      function () {
        return require("private-next-pages/homes/[modelNumber].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homes/[modelNumber]"])
      });
    }
  